module.exports = __webpack_public_path__ + "img/ingredienten-briesoep.e66f9531.jpeg";